// Define API endpoint constants for user management
export const API_URLS = {
  USER_MANAGEMENT: {
    SEARCH: 'usermanagement/api/user/search',
    DELETE_BY_ID: 'usermanagement/api/user',
    MASTER_DATA: 'usermanagement/api/User/MasterData',
    CREATE_USER: 'usermanagement/api/User',
    LOGGED_IN_USER: 'usermanagement/api/user/loggedInUser',
    SLIM_DATA: 'usermanagement/api/user',
  },
  RELEASE_NOTES: {
    LATEST: 'usermanagement/api/User/api/ReleaseNotes/Latest',
    ALL: 'usermanagement/api/User/api/ReleaseNotes/All',
  },
  MOTOR_SERVICE: {
    SEARCH: 'motorservice/api/MotorInvestigation/Search',
    SERVICE_CONNECT: 'motorservice/api/ServiceConnect',
    SOLUTION_SEARCH: 'motorservice/api/MotorInvestigation/Solution/Search',
    INVESTIGATION_DETAILS: 'motorservice/api/MotorInvestigation/Solution/Details',
    MACHINE_TYPE: 'motorservice/api/Motor/MachineType',
    GET_MOTOR_ARRANGEMENT : 'motorservice/api/Motor/Arrangement',
    SAVE_MOTOR_ARRANGEMENT : 'motorservice/api/Motor/Arrangement',
    GET_MOTOR_ARRANGEMENT_IMAGE : 'motorservice/api/Motor/Arrangement/ImageUrl',
    CHECK_AVAILABLE_SOLUTION: 'motorservice/api/MotorInvestigation/Solution/CheckAvailableSolution',
    MOTOR_DATA: 'motorservice/api/Motor/MotorData',
    SOLUTION_LOG: 'motorservice/api/Motor/SolutionLog',
  },
  MOTOR_LIST: {
    SEARCH: 'motorservice/api/Motor/Search',
    ARCHIVE: 'motorservice/api/Motor/Archive',
    UNARCHIVE: 'motorservice/api/Motor/UnArchive',
    ELECTRICAL_DATA: 'motorservice/api/Motor/ElectricalData',
    MECHANICAL_DATA: 'motorservice/api/Motor/MechanicalData',
    DELETE_DATA: 'motorservice/api/Motor/Delete',
  },
  MOTOR_INVESTIGATION:{
    SEARCH: 'motorservice/api/MotorInvestigationTicket/Search',
    INSIGHTS: 'motorservice/api/MotorInvestigationTicket/Insights',
    SAVE_INTERNAL_SEARCH_PARAMETERS: 'motorservice/api/MotorInvestigationTicket/Flow/Parameter',
    SEARCH_INTERNAL_AVAILABLE_ALTERNATIVE: 'motorservice/api/motorInvestigationTicket/search/internalalternative',
    CO2_COEFFICIENT: 'motorservice/api/MotorInvestigation/CO2Coefficient',
    FETCH_INTERNAL_AVAILABLE_ALTERNATIVE: 'motorservice/api/MotorInvestigationTicket/Flow/Parameter',
    FETCH_INVESTIGATION_COMPARISON_DATA: '/motorservice/api/motorInvestigationTicket/flow/comparisondata',
    FETCH_REPORT_COMPARISON_DATA: '/motorservice/api/motorInvestigationTicket/Report/Comparisondata',
    SAVE_ELECTRICAL_DATA: 'motorservice/api/motorInvestigationTicket/flow/comparisondata/electrical',
    SAVE_MECHANICAL_DATA: 'motorservice/api/motorInvestigationTicket/flow/comparisondata/mechanical',
    FETCH_MATCHED_ALTERNATIVE: 'motorservice/api/MotorInvestigationTicket/Flow/MatchedAlternative',
    SAVE_REPORT: 'motorservice/api/MotorInvestigationTicket/Report',
    FETCH_REPORT: 'motorservice/api/MotorInvestigationTicket/Report',
    SEND_REPORT_FOR_APPROVAL: 'motorservice/api/MotorInvestigationTicket/SendForApprove',
    MATCH_NO_MATCH: 'motorservice/api/MotorInvestigationTicket/Alternative/Match',
    EXTERNAL_INVESTIGATION_DATA: 'motorservice/api/MotorInvestigationTicket/ExternalInvestigationData',
    SAVE_EXTERNAL_INVESTIGATION_DATA: 'motorservice/api/MotorInvestigationTicket/ExternalInvestigationData',
    SAVE_EXTERNAL_INVESTIGATION_ALTERNATIVE_DATA: 'motorservice/api/MotorInvestigationTicket/ExternalInvestigationAlternative',
    EXTERNAL_INVESTIGATION__ELECTRICAL_ALTERNATIVE_DATA: 'motorservice/api/MotorInvestigationTicket/ExternalInvestigationAlternative/Electrical',
    EXTERNAL_INVESTIGATION__MECHANICAL_ALTERNATIVE_DATA : 'motorservice/api/MotorInvestigationTicket/ExternalInvestigationAlternative/Mechanical',
    DELETE_EXTERNAL_INVESTIGATION_ALTERNATIVE_DATA: 'motorservice/api/MotorInvestigationTicket/ExternalInvestigationAlternative/Delete',
    DUPLICATE_CHECK: 'motorservice/api/MotorInvestigationTicket/DuplicateCheck',
    UPLOAD_REPORT_DOCUMENTS: 'motorservice/api/MotorInvestigationTicket/ReportDocument',
    DELETE_REPORT_DOCUMENTS: 'motorservice/api/MotorInvestigationTicket/DeleteReportDocument',
    DOWNLOAD_REPORT_DOCUMENTS : 'motorservice/api/MotorInvestigationTicket/DownloadReportDocument',
    FETCH_REPORT_PDF_COMPARISON_DATA: 'motorservice/api/MotorInvestigationTicket/ReportPdf/Comparisondata',
    CLOSE_INVESTIGATION_STATUS: 'motorservice/api/MotorInvestigationTicket/CloseInvestigationStatus',
    ARCHIVE: 'motorservice/api/MotorInvestigation/Archive',
    UNARCHIVE: 'motorservice/api/MotorInvestigation/UnArchive',
    DETAILS: 'motorservice/api/MotorInvestigation/Details',
    SAVE_DETAILS: 'motorservice/api/MotorInvestigation/Details/Save',
    DELETE_RECORD: 'motorservice/api/MotorInvestigation/Delete'
  },
  DRIVE_INVESTIGATION: {
    SEARCH: 'driveservice/api/DriveInvestigation/Search',
    SOLUTION_SEARCH: 'driveservice/api/Drive/Solution/Search',
    SOLUTION_DETAILS: 'driveservice/api/Drive/Solution/Details',
    DRIVE_DATA: 'driveservice/api/Drive/DriveData',
    ARCHIVE: 'driveservice/api/Drive/Archive',
    UNARCHIVE: 'driveservice/api/Drive/Unarchive',
  },
  ELEKTRONIKON: {
    SEARCH: 'elektronikonservice/api/ElektronikonInvestigation/Search',
    SOLUTION_SEARCH: 'elektronikonservice/api/Elektronikon/Solution/Search',
    SOLUTION_DETAILS: 'elektronikonservice/api/Elektronikon/Solution/Details',
  },
  MOTOR_INVESTIGATION_TICKET:{
    CREATE_TICKET: 'motorservice/api/MotorInvestigationTicket/Create',
    MARKETING_TICKET: 'motorservice/api/MotorInvestigationTicket/Marketing/Create'
  },
  MOTOR:{
    MASTER_DATA: 'motorservice/api/Motor/MasterData',
    NO_OF_POLES_MASTER_DATA: 'motorservice/api/Motor/MasterData/NoOfPoles',
  },
  USER_TICKET: {
    SEARCH: 'motorservice/api/MotorInvestigationTicket/userticket/search',
    ADD_FOLLOWER: 'motorservice/api/MotorInvestigationTicket/Follower/Add',
  },
  MOTOR_INVESTIGATION_APPROVAL:{
    SEARCH: 'motorservice/api/MotorInvestigationApproval/Search',
    COMMENTS: 'motorservice/api/MotorInvestigationApproval/Comments',
    APPROVE: 'motorservice/api/MotorInvestigationApproval/Approve',
    SEND_BACK: 'motorservice/api/MotorInvestigationApproval/SendBack',
    SET_EXTERNAL_INVESTIGATION_STATUS : 'motorservice/api/MotorInvestigationApproval/SetExternalInvestigationStatus',
    INSIGHTS: 'motorservice/api/MotorInvestigationApproval/Insights',
  }
};
